$(document).ready(function() {
      //https://github.com/mebjas/html5-qrcode
      // This method will trigger user permissions
      const html5QrCode = new Html5Qrcode("reader");
     
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      var cameraId;
      // This method will trigger user permissions
      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          const cameraId = devices[0].id;
          console.log(cameraId);
          var cartItems = new Array();
          html5QrCode.start(
            { facingMode: { exact: "environment"} }, 
           
           {
              fps: 1,    // sets the framerate to 2 frame per second 
              qrbox: 310,  // sets only 250 X 250 region of viewfinder to
                          // scannable, rest shaded.
             aspectRatio: 1.0,
             rememberLastUsedCamera: true,
             supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA]
           },
           qrCodeMessage => {
              const id = qrCodeMessage.substring(qrCodeMessage.lastIndexOf('/') + 1);
             
              if(!cartItems.find(i => (i === qrCodeMessage))) {
                window.fetch(qrCodeMessage); 
                cartItems.push(qrCodeMessage);
                if($('#cartItemCount').text().length > 0) {
                  const currentCount = $('#cartItemCount').text().substring(1, $('#cartItemCount').text().length-1);
                  const totalCount = Number(currentCount) + 1;
                  $('#cartItemCount').text('(' + totalCount + ')');
                }  else {
                  $('#cartItemCount').text('(' + cartItems.length + ')');
                }
              }
           },
           errorMessage => {
              
           })
           .catch(err => {
               console.warn(`Unable to start scanning, error: ${err}`);
           });
        }
      }).catch(err => {
        console.warn(`Unable to get device, error: ${err}`);
      });

    
});